export default __webpack_public_path__ + "static/media/pnsv_stand_GrupoModelo.37bd8d7c.png";